import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Veracode extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 26 24"
        {...otherProps}
      >
        <path d="M9.04,2.921a9.065,9.065,0,1,0,.05,0Zm0,14.666a5.593,5.593,0,0,1,0-11.178c3.924,0,5.391,3.473,5.391,5.646a5.4,5.4,0,0,1-5.262,5.534H9.04Zm11.17,3.147V6.594H17.387V3.205h6.492v17.5H20.21Z" />
      </svg>
    );
  }
}

export default Veracode;
